import { defineComponent as y, computed as l, createElementBlock as c, openBlock as a, normalizeStyle as A, normalizeClass as f, withDirectives as S, createElementVNode as n, renderSlot as h, vModelCheckbox as I, createCommentVNode as s, createVNode as k, toDisplayString as p, withCtx as L, createBlock as F } from "vue";
import { _ as C } from "./Icon.ce.vue_vue_type_script_setup_true_lang-CdOC0ycX.js";
import { _ as B } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
/* empty css                                                                */
import { _ as w } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const D = { class: "arbo-toggle__wrapper" }, T = {
  key: 0,
  class: "arbo-toggle__label prefix"
}, V = { class: "arbo-toggle__circle-dot" }, N = {
  key: 1,
  class: "arbo-toggle__label suffix"
}, P = /* @__PURE__ */ y({
  __name: "Toggle",
  props: {
    showTooltip: {
      type: Boolean,
      default: !0
    },
    prefixActiveLabel: {
      type: String,
      default: "Prefix Active"
    },
    suffixActiveLabel: {
      type: String,
      default: "Suffix Active"
    },
    activeIcon: {
      type: String,
      default: ""
    },
    prefixInActiveLabel: {
      type: String,
      default: "Prefix In-active"
    },
    suffixInActiveLabel: {
      type: String,
      default: "Suffix In-active"
    },
    inActiveIcon: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: !1
    },
    sharedStyles: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:value"],
  setup(o, { emit: b }) {
    const e = o, g = b, t = l({
      get: () => e.value,
      set: (i) => {
        g("update:value", i);
      }
    });
    function _() {
      e.disable || (t.value = !t.value);
    }
    const r = l(() => t.value ? e.activeIcon : e.inActiveIcon), u = l(() => t.value ? e.prefixActiveLabel : e.prefixInActiveLabel), v = l(() => t.value ? e.suffixActiveLabel : e.suffixInActiveLabel), m = l(() => ({
      "--active-bg-color": "#F7941D",
      "--inactive-bg-color": "#A6A6A6",
      "--active-text-label-color": "#232323",
      "--inactive-text-label-color": "#232323",
      "--active-icon-color": "#F7941D",
      "--inactive-icon-color": "#FFFFFF",
      ...e.sharedStyles
    }));
    return (i, d) => (a(), c("div", {
      class: f(["arbo-toggle", { active: t.value, disable: e.disable }]),
      style: A(m.value)
    }, [
      S(n("input", {
        class: "arbo-toggle__input",
        type: "checkbox",
        "onUpdate:modelValue": d[0] || (d[0] = (x) => t.value = x)
      }, null, 512), [
        [I, t.value]
      ]),
      n("div", D, [
        u.value ? (a(), c("div", T, p(u.value), 1)) : s("", !0),
        k(B, {
          class: "arbo-toggle__slider",
          onClick: _,
          content: o.showTooltip && o.disable ? "Disabled" : "",
          delay: [300, 0]
        }, {
          default: L(() => [
            n("div", V, [
              r.value ? (a(), F(C, {
                key: 0,
                class: f(["arbo-toggle__slider--icon", { active: t.value }]),
                name: r.value
              }, null, 8, ["name", "class"])) : s("", !0)
            ])
          ]),
          _: 1
        }, 8, ["content"]),
        v.value ? (a(), c("div", N, p(v.value), 1)) : s("", !0)
      ]),
      h(i.$slots, "append", {}, void 0, !0)
    ], 6));
  }
}), O = /* @__PURE__ */ w(P, [["__scopeId", "data-v-9e3c4656"]]);
export {
  O as default
};
